import { render, staticRenderFns } from "./Lesson4.vue?vue&type=template&id=06d594ea&scoped=true&"
import script from "./Lesson4.vue?vue&type=script&lang=js&"
export * from "./Lesson4.vue?vue&type=script&lang=js&"
import style0 from "./Lesson4.vue?vue&type=style&index=0&id=06d594ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d594ea",
  null
  
)

export default component.exports